import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
 HostListener,
  ElementRef,
} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-v2',
  templateUrl: './header-v2.component.html',
  styleUrl: './header-v2.component.scss'
})
export class HeaderV2Component {
headerTabs: any=[];
  isHeaderTabVisible: boolean = false;
  typeSelected: string;
  userName: any;
  userId: string;
  platformApiUrl: any;
  isShowProfilecard: boolean = false;
  moduleByteMap: any;
  response: any;
  allHeadersTab: any = [];
  iconHeaders: any = [];
  sideHeaders: any = [];
  platformUrl: any;
  headerTabsObs: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  moduleBytes = new BehaviorSubject<any>('');

  DEV_PLATFORM_URL =
  'https://dev.platform.dacoval.com';
  QA_PLATFORM_URL =
  'https://qa.platform.dacoval.com';
  UAT_PLATFORM_URL =
  'https://uat.platform.dacoval.com';
  PROD_PLATFORM_URL = 'https://platform.dacoval.com';

  DEV_PLATFORM_API_URL =
  'https://dev-backend.platform.dacoval.com/dmint-platform/api';
  QA_PLATFORM_API_URL =
  'https://qa-backend.platform.dacoval.com/dmint-platform/api';
  UAT_PLATFORM_API_URL =
  'https://uat-backend.platform.dacoval.com/dmint-platform/api';
  PROD_PLATFORM_API_URL = 'https://backend.platform.dacoval.com/dmint-platform/api';
  homeUrl: any;
  isUserLoggedIn: boolean;
  errMsg: any;
  closeSign: string;
  showErrorMessageWithPopup: boolean;
  subscriptionMsg = 'Please contact DMINT Administrator to get subscription of the same';
  modulesForHiddenHeader: any=[];
  isProfileCardOpen: boolean = false;



  constructor(
    public auth: AuthService,    
    private spinner: NgxSpinnerService,
    private http: HttpClient, private eRef: ElementRef
  ) {
    this.typeSelected = 'ball-clip-rotate-pulse';
    this.platformApiUrl =  environment.type.includes('qa')
                          ? this.QA_PLATFORM_API_URL
                          : environment.type.includes('uat')
                         ? this.UAT_PLATFORM_API_URL
                         : this.DEV_PLATFORM_API_URL;
    //this.platformApiUrl = this.PROD_PLATFORM_API_URL;

    this.platformUrl = environment.type.includes('qa')
                    ? this.QA_PLATFORM_URL
                    : environment.type.includes('uat')
                    ? this.UAT_PLATFORM_URL
                    : this.DEV_PLATFORM_URL;
    //this.platformUrl =  this.PROD_PLATFORM_URL;
  }

  ngOnInit(): void {
    this.spinner.show();
    const userId = sessionStorage.getItem('userId');
    if (userId != undefined) {
      this.headerTabsObs.subscribe((headers) => {
        if (headers == undefined || headers.length == 0) this.getHeaders();
        else this.allHeadersTab = headers;
      });

      this.moduleBytes.subscribe((moduleBytes) => {
        if (moduleBytes == undefined || moduleBytes.length == 0) this.downloadImages();
        else this.moduleByteMap = moduleBytes as Object;        
      });
    }

    this.auth.user$.subscribe((user) => {
      this.userName = user?.name;
    });
  }

  getHeaders() {
    this.spinner.show();
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('parentToken').toString()}`,
    //  userId: sessionStorage.getItem('userId'),
      authId: sessionStorage.getItem('id')
    });
    return this.http
      .post<any>(`${this.platformApiUrl}/v1/platformInfo`, null, {      
        headers: headers,
      })
      .subscribe((res: any) => {
        const headerResult = res.result.headers;
        this.homeUrl = res.result.urls.frontendUrl;
        this.allHeadersTab = headerResult;
        this.setHeaderTabs(this.allHeadersTab);

        this.allHeadersTab.forEach((header: any) => {
          
          if(header.homePageItem){     
            if(header.menuImagePath.includes('_icon.') && header?.isIgnore==false)   
              this.iconHeaders.push(header); 
            else       
              this.headerTabs.push(header);                                        
          }
          else 
            this.sideHeaders.push(header); 

          if(header?.isIgnore){
            this.modulesForHiddenHeader = [...header.modules];   
          }
        });
                      
        this.spinner.hide();
      });
  }

  downloadImages(){
    this.http
    .get<Blob>(`${this.platformApiUrl}/v1/downloadAllCapabilityImages`)        
    .subscribe((res) => {
      this.response = res;
      this.moduleByteMap = this.response.result as Object;      
      this.setModuleByte(this.moduleByteMap);
    }); 
  }

  openLink(link: any) {
    window.open(`${link}`, '_blank');
  }

  logout() {
    this.spinner.hide();
    sessionStorage.clear();
    this.auth.logout();
  }

  onLoginCall() {
      this.auth.loginWithRedirect();
  }

  onShowUserProfile() {
    this.isShowProfilecard = !this.isShowProfilecard;
  }

  setHeaderTabs(headerTabs: any) {
    this.headerTabsObs.next(headerTabs);
  }
  setModuleByte(moduleBytesMap: any){
    this.moduleBytes.next(moduleBytesMap);
  }
   @HostListener('document:click', ['$event'])
    clickout(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isProfileCardOpen = false;
    }
  }

  getSubscribePopup() {
    this.errMsg = this.subscriptionMsg;
    this.closeSign = 'OK';
    this.showErrorMessageWithPopup = true;
  }
   onCloseHandler() {
    this.errMsg = null;
    this.showErrorMessageWithPopup = false;
  }
  openCopilotApp() {
    this.userId = sessionStorage.getItem('userId');
    this.isUserLoggedIn = sessionStorage.getItem('userId') != 'undefined'
      && sessionStorage.getItem('userId') != undefined ? true : false;      

    let copilotModuleDetails = this.modulesForHiddenHeader[0];
    if (copilotModuleDetails.subscription == false && this.userId && this.isUserLoggedIn) {
      this.getSubscribePopup();
    } else if (copilotModuleDetails.subscription && this.userId && this.isUserLoggedIn) {
      let envValue;
      if (environment.type.includes('dev'))
        envValue = 'dev'
      else if (environment.type.includes('qa'))
        envValue = 'qa'
      else if (environment.type.includes('uat'))
        envValue = 'uat'
      else
        envValue = 'prod'


      const queryParam = btoa(`env=${envValue}`);
      window.open(`${copilotModuleDetails.moduleLink}?${queryParam}`, '_blank');
    } else if (!this.userId && !this.isUserLoggedIn) {
      this.onLoginCall();
    }
  }

   openProfileCard() {
    this.isProfileCardOpen = !this.isProfileCardOpen;
  }

}
